import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';

const cognitoClientConfirmPassword = (code, newPassword, userName, onSuccess, onFailure) => {
  const poolData = {
    UserPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  };
  const userPool = new CognitoUserPool(poolData);
  const userData = {
    Username: userName,
    Pool: userPool,
  };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.confirmPassword(code.toString(), newPassword, {
    onSuccess,
    onFailure,
  });
};

export default cognitoClientConfirmPassword;
